import script from "./FraudAlertsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FraudAlertsTable.vue?vue&type=script&setup=true&lang=js"

import "./FraudAlertsTable.vue?vue&type=style&index=0&id=cc606680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc606680"]])

export default __exports__